import Model, { attr, belongsTo } from '@ember-data/model';
import type { AsyncBelongsTo } from '@ember-data/model';
import type LocationModel from 'garaje/models/location';

export default class IdScanConfiguration extends Model {
  @attr('boolean', { defaultValue: false }) declare nameMatchRequired: boolean;
  @attr('boolean', { defaultValue: false }) declare faceMatchRequired: boolean;

  @belongsTo('location', { async: true, inverse: null })
  declare location: AsyncBelongsTo<LocationModel>;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'id-scan-configuration': IdScanConfiguration;
  }
}
